'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlSearchField", function ($http, $compile, $debounce, $timeout, $q, keyCodes, objectUtils) {
  var defaultConfig = {
    searchUrl: null,
    searchParameter: "q",
    labelAttribute: "id",
    /**
     * permet de définir une valeur par défaut : indique un champs present dans le scope
     */
    stickToValue: null,
    minLength: null,
    resultTemplate: '<span>{{result.id || "must config resultTemplate"}}</span>'
  };
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: require("./tlSearchField.html"),
    controllerAs: "searchFieldCtrl",
    link: function link($scope, $el, $attrs, ctrl) {
      var configName = $attrs.config;
      var unwatch = $scope.$watch(configName, function (config) {
        if (config != null) {
          unwatch();
          ctrl.initialize(config);
        }
      });
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        input = $element.find("input"),
        config = null,
        blurTimeout = null,
        requestCanceler = null,
        resultLinkFn = null;
      ctrl.initialize = function (_config) {
        config = _.extend({}, defaultConfig, _config);
        resultLinkFn = $compile(config.resultTemplate);
        input.on("input", function () {
          debouncedHandler($.trim(input.val()));
        });
        if (config.stickToValue != null) {
          $scope.$watch(config.stickToValue, function (value) {
            if (value) {
              $scope.search.q = value;
            }
          });
        }
        if (config.minLength != null) {
          $scope.search.minLength = config.minLength;
        } else {
          $scope.search.minLength = 2;
        }
      };
      ctrl.getResultLink = function () {
        return resultLinkFn;
      };
      $scope.search = {
        q: ""
      };
      $scope.results = [];
      $scope.selected = null;
      $scope.loadingResults = false;
      $scope.active = false;
      var cancelBlurTimeout = function cancelBlurTimeout() {
        if (blurTimeout) {
          $timeout.cancel(blurTimeout);
          blurTimeout = false;
        }
      };
      var setActive = function setActive() {
        cancelBlurTimeout();
        $scope.active = true;
      };
      var setInactive = function setInactive() {
        $scope.active = false;
      };
      $scope.onFocus = function () {
        if ($scope.search.q.length >= $scope.search.minLength) {
          setActive();
        }
      };
      $scope.setActiveItem = function (itemIdx) {
        $scope.selected = itemIdx;
      };
      $scope.onBlur = function () {
        $timeout(function () {
          $scope.active = false;
        }, 250);
      };
      $scope.onKeyDown = function (event) {
        var keyCode = event.which;
        switch (keyCode) {
          case keyCodes.UP:
            {
              if ($scope.selected != null) {
                $scope.selected -= 1;
                if ($scope.selected < 0) {
                  $scope.selected = null;
                }
              }
              event.preventDefault();
              break;
            }
          case keyCodes.DOWN:
            {
              if ($scope.selected == null) {
                $scope.selected = 0;
              } else {
                $scope.selected++;
              }
              event.preventDefault();
              break;
            }
          case keyCodes.ENTER:
            {
              if ($scope.results.length === 0) {
                return;
              }
              var selectedIdx = $scope.results.length === 1 ? 0 : $scope.selected;
              if (selectedIdx != null) {
                $scope.onResultClick($scope.results[selectedIdx]);
                setInactive();
              }
              event.preventDefault();
              break;
            }
          case keyCodes.ESCAPE:
            {
              setInactive();
              event.preventDefault();
              break;
            }
        }
      };
      $scope.onResultClick = function (result) {
        $scope.search.q = objectUtils.getProperty(result, config.labelAttribute);
        config.onSelect(result);
      };
      var performSearch = function performSearch(query) {
        if (requestCanceler) {
          requestCanceler();
        }
        var searchPromise;
        if (config.searchUrl) {
          var deferredCancel = $q.defer();
          requestCanceler = function requestCanceler() {
            deferredCancel.resolve();
          };
          var params = {};
          if (config.extraParams) {
            params = _.extend(params, $scope[config.extraParams]);
          }
          params[config.searchParameter] = query;
          searchPromise = $http.get(config.searchUrl, {
            params: params,
            timeout: deferredCancel.promise
          }).then(function (response) {
            return response.data;
          });
        } else {
          searchPromise = config.searchMethod(query, requestCanceler);
          requestCanceler = searchPromise.cancel;
        }
        $q.when(searchPromise).then(function (results) {
          $scope.loadingResults = false;
          $scope.selected = null;
          $scope.results = results;
          requestCanceler = null;
        });
      };
      var refreshSuggestions = function refreshSuggestions(query) {
        setActive();
        $scope.loadingResults = true;
        performSearch(query);
      };
      var debouncedHandler = $debounce(function (search) {
        var q = search || "";
        if (q.length < $scope.search.minLength) {
          $scope.results = [];
          return;
        }
        refreshSuggestions(search);
      }, 250);
    }
  };
});
ngModule.directive("tlSearchFieldResult", function () {
  return {
    restrict: "A",
    scope: true,
    require: "^tlSearchField",
    link: function link($scope, $el, $attrs, ctrl) {
      var linkFn = ctrl.getResultLink();
      linkFn($scope, function (clone) {
        clone.appendTo($el);
      });
    }
  };
});
ngModule.filter("underlineSearchResultMatch", function () {
  return function searchResultUnderlineFilter(value, term) {
    if (term == null || !term.length) {
      return value;
    }
    var termRegexp = new RegExp(term.replace(/[.()\[\]]/g, "").replace(/[- ]/g, "[- ]"), "i"),
      regexpMatch = termRegexp.exec(value);
    if (regexpMatch == null) {
      return value;
    }
    var matchIndex = regexpMatch.index,
      matchLength = regexpMatch[0].length;
    var prefix = value.substring(0, matchIndex),
      highlight = value.substr(matchIndex, matchLength),
      suffix = value.substring(matchIndex + matchLength);
    return "<span>" + prefix + "</span>" + "<span class='b'>" + highlight + "</span>" + "<span>" + suffix + "</span>";
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/searchField/tlSearchField.js
// module id = 2950
// module chunks = 13